<template>
    <div>
        <Carrito 
            :carritoItems="carritoItems" 
            :secondsLeft="carrito?.seconds_left"
            :button_color="button_color" 
            @eliminarProducto="eliminarProducto"
            @irADetalleCarrito="irADetalleCarrito"
        />
        <ModalCuentaAtrasCarrito @close="close('carrito-terminado')"/>
        <ModalCuentraAtrasAvisoCarrito :secondsLeft="carrito?.seconds_left" @close="close('carrito-aviso')"/>
    </div>
</template>

<script>
    import Carrito from '../../common/carrito/Carrito.vue';
    import ModalCuentaAtrasCarrito from '../../common/carrito/ModalCuentaAtrasCarrito.vue';
    import ModalCuentraAtrasAvisoCarrito from '../../common/carrito/ModalCuentraAtrasAvisoCarrito.vue';

    export default {
        props: {
            button_color: String,
        },
        methods: {
            getCarritoActivo() {
                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.activo'), { filters: { uuid: localStorage.getItem('uuid') } });
            },
            eliminarProducto(item_id) {
                const params = {
                    filters: { uuid: localStorage.getItem('uuid') },
                    cart_id: this.carrito?.id,
                    item_id: item_id
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.delete-items'), params).then(res => {
                    this.$toast.success('Entrada borrada correctamente');
                    this.$store.dispatch('USUARIO_CARRITO_ITEMS', { cart_id: this.carrito.id, filters: { uuid: localStorage.getItem('uuid') }})
                        .then(() => {
                            if (this.carritoItems.length === 0) {
                                this.$store.dispatch('USUARIO_CARRITO_DELETE', { cart_id: this.carrito.id, filters: { uuid: localStorage.getItem('uuid') }});
                            }
                        });
                }).catch(err => {
                    console.error('Error actualizando carrito online:', err);
                });
            },
            irADetalleCarrito() {
                this.$router.push({ name: 'front.carrito' });
            },
            close(modal) {
                this.$modal.hide(modal);
            },
        },
        watch: {
            'carrito.seconds_left': function(newVal) {
                if (newVal === 0) {
                    this.$modal.show('carrito-terminado');
                    this.$router.push({ path: '/eventos' });
                }
            }
        },
        computed: {
            carrito() {
                return this.$store.getters.getCarritoActivoOnline;
            },
            carritoItems() {
                return this.$store.getters.getCarritoItemsOnline;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        mounted() {
            this.getCarritoActivo();
        },
        components: { Carrito, ModalCuentaAtrasCarrito, ModalCuentraAtrasAvisoCarrito },
    };
</script>
